
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

import Accueil from '@/views/Accueil'
import SelectDicoSetting from '@/views/SelectDicoSetting'
import Dicos from '@/views/Dicos'
import Submission from '@/views/Submission'
import Preferences from '@/views/Preferences'
import DicoFrame from '@/views/DicoFrame'
import Login from '@/views/Login'
import Plugin from '@/views/Plugin'
import Documentation from '@/views/Documentation'
import TestPL from '@/views/TestPL'
import Clients from '@/views/Clients'
import Client from '@/views/Client'
import Typographie from '@/views/Typographie'
import User from '@/views/User'
import Host from '@/views/Host'
import AccessDenied from '@/views/AccessDenied'
import NotFound from '@/views/NotFound'
import Activation from "@/views/Activation"
import PreferencesFrame from "@/views/PreferencesFrame"
import VariantsFrame from "@/views/VariantsFrame"

import { RoleEnum } from '../classes/enums'

import { noEmpty } from '../constantes'


// Router
const routes = [
    {
        name: 'Default',
        path: '/',
        //component: Dicos,
        redirect: "/accueil"
    },
    {
        name: 'Activation',
        path:"/activation",
        component: Activation,
        meta : {
            title:"Activation",
            acessrole: [], // tous le monde y a acces
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Acceuil',
        path:"/accueil",
        component: Accueil,
        meta : {
            title:"Accueil",
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'SelectDicoSetting',
        path: '/selectSetting',
        component: SelectDicoSetting,
        props:true,
        meta : {
            title: 'Configuration',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Dicos',
        path: '/dictionary',
        component: Dicos,
        props:true,
        meta : {
            title: 'Dictionnaires',
            acessrole: [RoleEnum.SUPERADMIN.value ,RoleEnum.ADMIN.value ,RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'Submission',
        path: '/submission',
        component: Submission,
        meta : {
            title: 'Soumissions',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'Preferences',
        path: '/preferences',
        component: Preferences,
        meta : {
            title: 'Préférences',
            acessrole: [RoleEnum.SUPERADMIN.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'DicoFrame',
        path: '/dictionary/:diconame',
        component: DicoFrame,
        props:true,
        meta : {
            title: (route) => (route.params.diconame),
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'DicoFrameAdd',
        path: '/dictionary/:diconame/:word',
        component: DicoFrame,
        props:true,
        meta : {
            title: (route) => (route.params.diconame),
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Login',
        path: '/login',
        component: Login,
        meta : {
            title: 'Connection',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Documentation',
        path: '/documentation',
        component: Documentation,
        meta : {
            title: 'Documentation',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Plugin',
        path: '/Plugin',
        component: Plugin,
        meta : {
            title: 'Plug-in Js',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'TestPL',
        path: '/test',
        component: TestPL,
        props:true,
        meta : {
            title: 'Page de test',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Clients',
        path: '/clients',
        component: Clients,
        meta : {
            title: 'Clients',
            //acessrole: ['RoleEnum.SUPERADMIN'],
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Client',
        path: '/clients/:clientId',
        component: Client,
        props:true,
        meta : {
            title: 'Client',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'User',
        path: '/users/:userId',
        component: User,
        props:true,
        meta : {
            title: 'Utilisateur',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Host',
        path: '/hosts/:hostId',
        component: Host,
        props:true,
        meta : {
            title: 'Domaines',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    {
        name: 'Typographie',
        path: '/typographie',
        component: Typographie,
        meta : {
            title: 'Typographie',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'PreferencesFrame',
        path: '/preferences/edit',
        component: PreferencesFrame,
        meta : {
            title: 'Préférences',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    {
        name: 'VariantsFrame',
        path: '/variants',
        component: VariantsFrame,
        props:true,
        meta : {
            title: 'Variantes',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: true,
        }
    },
    { 
        name: 'AccesDenied',
        path: '/accesdenied', 
        component: AccessDenied,
        props:true,
        meta : {
            title: 'Acces non autorisé',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
    { 
        name: 'NotFound',
        path: '/:pathMatch(.*)*', 
        component: NotFound,
        props:true,
        meta : {
            title: '404 Page Non Touvée',
            acessrole: [RoleEnum.SUPERADMIN.value, RoleEnum.ADMIN.value, RoleEnum.LINGUIST.value],
            showRefreshConfigBtn: false,
        }
    },
];
/*
const router = createRouter({
  history:createWebHashHistory(),//createWebHistory(process.env.BASE_URL),
  routes, // short for `routes: routes`
  base :'/'
});


router.beforeEach((to, from, next) => {
  // Ici on peut test si u user est log et restreindre les acces de certaines pages
  // On peux simplifier en rajouter un param dans meta, comme le title

  // const publicPages = ['/login', '/register', '/home'];
  // const authRequired = !publicPages.includes(to.path);
  // const loggedIn = localStorage.getItem('user');
  // // trying to access a restricted page + not logged in
  // // redirect to login page
  // if (authRequired && !loggedIn) {
  //   next('/login');
  // } else {
  //   next();
  // }
  var gotoLogin = (to.name == "Login");
  //var isConnected = FctUtils.methods.noEmpty(store.state.currentTokenInfo) && FctUtils.methods.noEmpty(store.state.currentUser);
  var isConnected = store.state.currentTokenInfo && (store.state.currentUser);
  //console.log("infos : "+JSON.stringify(store.state.currentTokenInfo));
  //console.log("user : "+JSON.stringify(store.state.currentUser));
  var cangoto = (to.meta.acessrole.indexOf(store.state.currentTokenInfo.role) != -1);
  var isTokenValid = store.getters.isTokenValid;
  console.log("from : " + from.meta.title + " / Token Valid " + isTokenValid);
  console.log("cangoto : " + to.meta.title +" / " + cangoto);


  if (!gotoLogin && (!isConnected || !isTokenValid)) {
      if (store) store.commit('logout', {router:router});
      next('/login');
  }
  else if(!cangoto && !gotoLogin) {
      next("/accesdenied")
  }
  else {
      next();
  }
});


router.afterEach((to, from) => {
  if (typeof to.meta.title === 'function') {
      document.title = to.meta.title(to);
  }
  else if (to.meta.title) {
      document.title = to.meta.title;
  }
});*/

export const createRouterInstance = (app, store) => {

    const router = createRouter({
        history:createWebHistory(process.env.BASE_URL),
        routes, // short for `routes: routes`
        base :'/'
    });
      
  
    router.beforeEach((to, from, next) => {
        // Ici on peut test si u user est log et restreindre les acces de certaines pages
        // On peux simplifier en rajouter un param dans meta, comme le title
      
        // const publicPages = ['/login', '/register', '/home'];
        // const authRequired = !publicPages.includes(to.path);
        // const loggedIn = localStorage.getItem('user');
        // // trying to access a restricted page + not logged in
        // // redirect to login page
        // if (authRequired && !loggedIn) {
        //   next('/login');
        // } else {
        //   next();
        // }
        var gotoLogin = (to.name == "Login");
        var gotoActivation = (to.name == "Activation") && (to.query.code != undefined);
        //var isConnected = FctUtils.methods.noEmpty(store.state.currentTokenInfo) && FctUtils.methods.noEmpty(store.state.currentUser);
        var isConnected = noEmpty(store.state.currentTokenInfo) && noEmpty(store.state.currentUser);
        //var isConnected = store.state.currentTokenInfo && (store.state.currentUser);
        //console.log("infos : "+JSON.stringify(store.state.currentTokenInfo));
        //console.log("user : "+JSON.stringify(store.state.currentUser));
        var cangoto = (to.meta.acessrole.indexOf(store.state.currentTokenInfo.role) != -1);
        var isTokenValid = store.getters.isTokenValid;

        // Si le token est valide, on le refresh si necessaire 
        // Refresh valide à partir de 10min avant expiration
        if (isTokenValid) {
            var isRefreshValid = store.getters.isRefreshValid;

            if (isRefreshValid) {
                if (store) store.dispatch("refresh");
            }
        }


        console.log("from : " + from.meta.title + " / Token Valid " + isTokenValid);
        console.log("cangoto : " + to.meta.title +" / " + cangoto);
      
      
        if (gotoActivation) {
            next();
        }
        else if (!gotoLogin && (!isConnected || !isTokenValid)) {
            if (store) store.commit('logout', {router:router});
            next('/login');
        }
        else if(!cangoto && !gotoLogin) {
            next("/accesdenied")
        }
        else {
            next();
        }
    });
      
      
    router.afterEach((to, from) => {
        if (typeof to.meta.title === 'function') {
            document.title = to.meta.title(to);
        }
        else if (to.meta.title) {
            document.title = to.meta.title;
        }
    });
    
    
    return router
  }
